export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-breadcrumbs/index.ts